import { Checkbox } from "../../fields/checkbox";

export function CellCheckbox<T extends object>(props: {
  item: T;
  attr: keyof T;
  patch?: any;
}) {
  const model = props.patch ?? props.item;
  const checked = model[props.attr] as boolean;

  if (!props.patch) {
    return (
      <span
        className={
          checked
            ? "text-success-foreground font-semibold"
            : "text-danger-foreground font-semibold"
        }
      >
        {checked ? "✓ Yes" : "✗ No"}
      </span>
    );
  }

  return <Checkbox model={model} attr={props.attr} />;
}
